import React, { useRef, useState } from 'react';
import FeatherIcon from 'feather-icons-react';
import { Modal, Form, Input, message, Col } from 'antd';
import PropTypes from 'prop-types';
import { BasicFormWrapper2, VerticalFormStyleWrap } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { validatePassword } from '../../../components/utilities/utilities';
import { resetPassword } from '../../../Api/Services/UserApiService';

const Popup = ({ popup, setPopup }) => {

    const [form] = Form.useForm();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const handleClose = () => {
        setPopup(false);
    }
    const onSubmit = async (value) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        try {
            const { old, newPass } = value;
            const formData =
            {
                oldPassword: old,
                newPassword: newPass
            };
            const response = await resetPassword(formData)
            if (response.data.statusCode === 200) {
                setPopup(false)
                message.success("Password updated")
                loadingRef.current = false;
                setDelteClick(false)
            } else {
                loadingRef.current = false;
                setDelteClick(false)
                message.error("Password update failed, try again")
            }
        } catch (error) {
            loadingRef.current = false;
            setDelteClick(false)
            message.error(error)
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    return (
        <>
            <Modal
                title="Change Password"
                open={popup}
                onCancel={handleClose}
                // centered
                maskClosable={false}
                width={700}
                footer={[
                    <div>
                        <Button onClick={handleClose} className="gray-button" size="small">
                            <FeatherIcon icon="x" />Cancel
                        </Button>
                        <Button className='btn-add_new button_colors' htmlType="submit" size="small" onClick={() => form.submit()} loading={deleteClick} disabled={deleteClick}>
                            {!deleteClick && <FeatherIcon icon="save" />}Confirm
                        </Button>
                    </div>
                ]}
            >
                <div className="user-info-form" style={{ padding: "0px 20px" }}>
                    <BasicFormWrapper2>
                        <VerticalFormStyleWrap>
                            <div className="add-product-block">
                                <Form style={{ width: '100%' }} form={form} name="info" colon={false} onFinish={onSubmit} onFinishFailed={onFinishFailed}>
                                    <div className="add-product-content">
                                        <Col style={{ marginBottom: 20 }}>
                                            <Form.Item label="Old Password" name="old" rules={[{ required: true, message: 'Please enter old password', }]}>
                                                <Input.Password placeholder="Enter Old PassWord" />
                                            </Form.Item>
                                        </Col>
                                        <Col style={{ marginTop: 20 }}>
                                            <Form.Item label="New Password" name="newPass" rules={[{ required: true, message: 'Please enter new password' }, {
                                                validator: (_, value) => {
                                                    const error = validatePassword(value, 8, 50);
                                                    if (error) {
                                                        return Promise.reject(new Error(error));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            }]}>
                                                <Input.Password placeholder="Enter New Password" />
                                            </Form.Item>
                                        </Col>
                                    </div>
                                </Form>
                            </div>
                        </VerticalFormStyleWrap>
                    </BasicFormWrapper2>
                </div>
            </Modal>
        </>
    );
};

Popup.propTypes = {
    popup: PropTypes.bool.isRequired,
    setPopup: PropTypes.func.isRequired,

};

export default Popup;
